import React from 'react';
import { createRoot } from 'react-dom/client';
import { LoginCard } from './components/LoginCard';
import { parseJson } from '../../../utils/serde';
import '../../../styles/login.css';
type LoginProps = {
    info_message?: string | null;
    result_message?: string | null;
    next_url?: string;
    agent_value?: string;
    change_password_required?: boolean;
    action?: string;
};

function bootstrap() {
    const script = document.getElementById('login-props');
    const raw = script?.textContent || script?.innerHTML || '';
    const props = parseJson<LoginProps>(raw, {});

    const el = document.getElementById('login-react-root');
    if (!el) return;

    createRoot(el).render(
        <LoginCard
            infoMessage={props.info_message || null}
            errorMessage={props.result_message || null}
            nextUrl={props.next_url || ''}
            agentValue={props.agent_value || ''}
            changePasswordRequired={props.change_password_required === true}
            action={props.action || '/login'}
        />,
    );
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
} else {
    bootstrap();
}
